import { shape, func } from 'prop-types';

export default shape({
    get: func,
    set: func,
});
